import moment from 'moment';

export type Timeline = {
    st: number;
    ed: number;
    status: 'available' | 'unavailable' | 'close';
};

export const fnFormatTimeline = (timeline: Timeline) => {
    return {
        st: moment(timeline.st).format('HH:mm'),
        ed: moment(timeline.ed).format('HH:mm'),
        status: timeline.status,
    };
};

export class TimelineArray {
    private timelines: Timeline[];

    constructor(timelines: Timeline[]) {
        this.timelines = timelines;
    }

    cutByTimes(times: number[]): TimelineArray {
        const newTimelines = [...this.timelines];
        times.forEach((time) => {
            let index = newTimelines.findIndex((timeline) => time > timeline.st && time < timeline.ed);
            let whileCount = 0;
            while (index >= 0) {
                if (whileCount++ > 999) break;
                const timeline = newTimelines[index];
                const firstTimeline: Timeline = {
                    st: timeline.st,
                    ed: time,
                    status: timeline.status,
                };
                const secondTimeline: Timeline = {
                    st: time,
                    ed: timeline.ed,
                    status: timeline.status,
                };
                newTimelines.splice(index, 1, firstTimeline, secondTimeline);
                index = newTimelines.findIndex((timeline) => time > timeline.st && time < timeline.ed);
            }
        });
        return new TimelineArray(newTimelines);
    }

    cutByTimelines(_timelineArray: TimelineArray): TimelineArray {
        const newTimelines = [...this.timelines];
        _timelineArray.getTimelines().forEach((_timeline) => {
            let index = newTimelines.findIndex((timeline) => {
                const cond1 = _timeline.st > timeline.st && _timeline.st < timeline.ed;
                const cond2 = _timeline.ed > timeline.st && _timeline.ed < timeline.ed;
                const cond3 = _timeline.st <= timeline.st && _timeline.ed >= timeline.ed;
                return cond1 || cond2 || cond3;
            });
            let whileCount = 0;
            while (index >= 0) {
                if (whileCount++ > 5) break;
                const timeline = newTimelines[index];
                const cond1 = _timeline.st > timeline.st && _timeline.st < timeline.ed;
                const cond2 = _timeline.ed > timeline.st && _timeline.ed < timeline.ed;
                const firstTimeline = cond1
                    ? {
                          st: timeline.st,
                          ed: _timeline.st,
                          status: timeline.status,
                      }
                    : undefined;
                const secondTimeline = cond2
                    ? {
                          st: _timeline.ed,
                          ed: timeline.ed,
                          status: timeline.status,
                      }
                    : undefined;

                if (firstTimeline != undefined && secondTimeline != undefined) {
                    newTimelines.splice(index, 1, firstTimeline, secondTimeline);
                } else if (firstTimeline != undefined) {
                    newTimelines.splice(index, 1, firstTimeline);
                } else if (secondTimeline != undefined) {
                    newTimelines.splice(index, 1, secondTimeline);
                } else {
                    newTimelines.splice(index, 1);
                }
                index = newTimelines.findIndex((timeline) => {
                    const cond1 = _timeline.st > timeline.st && _timeline.st < timeline.ed;
                    const cond2 = _timeline.ed > timeline.st && _timeline.ed < timeline.ed;
                    const cond3 = _timeline.st <= timeline.st && _timeline.ed >= timeline.ed;
                    return cond1 || cond2 || cond3;
                });
            }
            newTimelines.push(_timeline);
        });
        return new TimelineArray(newTimelines);
    }

    sort(): TimelineArray {
        this.timelines = this.timelines.sort((a, b) => a.st - b.st);
        return this;
    }

    validate(newValue: number[]): boolean {
        if (newValue.length != 2) return false;
        const notAvailableTimelines = this.timelines.filter((timeline) => timeline.status != 'available');
        if (notAvailableTimelines.filter((timeline) => newValue[0] > timeline.st && newValue[0] < timeline.ed).length > 0) return false;
        if (notAvailableTimelines.filter((timeline) => newValue[1] > timeline.st && newValue[1] < timeline.ed).length > 0) return false;
        if (notAvailableTimelines.filter((timeline) => newValue[1] > timeline.st && newValue[1] < timeline.ed).length > 0) return false;
        if (
            notAvailableTimelines.filter((timeline) => Math.abs(timeline.st + timeline.ed - newValue[0] - newValue[1]) < 30 * 1000).length >
            0
        )
            return false;
        return true;
    }

    getTimelines(): Timeline[] {
        return this.timelines;
    }
}
